import mrRequest from "@/utils/request"

// 高性价比
export const getHomeGoodprice = () => {
  return mrRequest.get({ url: '/home/goodprice' })
}

// 高分房源
export const getHomeHighScore = () => {
  return mrRequest.get({ url: '/home/highscore' })
}

// 折扣优惠
export const getHomeDiscount = () => {
  return mrRequest.get({ url: '/home/discount' })
}

// 热门推荐
export const getHomeHotRecommend = () => {
  return mrRequest.get({ url: '/home/hotrecommenddest' })
}

// 向往城市
export const getHomeLongfor = () => {
  return mrRequest.get({ url: '/home/longfor' })
}

// plus房源
export const getHomePlus = () => {
  return mrRequest.get({ url: '/home/plus' })
}